import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'assets/scss/index.scss'
import './i18n'
import { App } from './App'

import config from 'devextreme/core/config'
import { licenseKey } from './license-key'

import { IxAppProvider } from './contexts/app-contexts'

config({ licenseKey })

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
    // <StrictMode>
        <IxAppProvider>
            <App />
        </IxAppProvider>
    // </StrictMode>
)
